import { accountModule, screenModule } from '@app/store'
import { computed, useContext, useRoute, watch } from '@nuxtjs/composition-api'
import { AvailableLang } from '@app/types/src/Lang'

export default function usePageCommon() {
  const context = useContext()
  const route = useRoute()

  const loading = computed(() => screenModule.loading)
  const errorMessage = computed({
    get: () => screenModule.errorMessage,
    set: (value: string) => screenModule.setErrorMessage(value),
  })
  watch(route, () => {
    screenModule.setErrorMessage('')
  })
  const lang = computed(() => accountModule.language)
  const isJP = computed(() => accountModule.language === AvailableLang.JP)
  return {
    loading,
    errorMessage,
    lang,
    isJP,
  }
}
